
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps, GetStaticPropsContext } from 'next';
import { Account } from 'shared/api/accounts';
import { Review } from 'shared/api/latestReviews';
import Page from 'shared/components/Page';
import { getVipAccountIds } from 'shared/components/Vip/vipConfigs';
import useTranslation from 'shared/hooks/useTranslation';
import getReviews from 'lib/cache/latestReviews/reviews';
import getVipAccounts from 'lib/cache/vipAccounts/vipAccounts';
import HeaderSection from 'modules/sellsPage/v2/HeaderSection';
import MainSection from 'modules/sellsPage/v2/MainSection';
import Trans from 'next-translate/Trans';
import dynamic from 'next/dynamic';
import Head from 'next/head';
const EmailSection = dynamic(() => import('modules/sellsPage/v2/EmailSection'));
const Mediation = dynamic(() => import('modules/sellsPage/v2/clientContact/Mediation'));
const CommentReview = dynamic(() => import('modules/sellsPage/v2/clientContact/CommentReview'));
const FindOutMore = dynamic(() => import('modules/sellsPage/v2/components/FindOutMore'));
const Vip = dynamic(() => import('shared/components/Vip-v2'));
type ClientContactProps = {
    latestReviews: Review[];
    vipAccounts: Account[];
};
function ClientContact({ latestReviews, vipAccounts }: ClientContactProps): JSX.Element {
    const { t, lang } = useTranslation('mediationSystemPage');
    return (<Page reviews={latestReviews} withFooter withLatestReviews>
      <Head>
        <title>{t('titleTag')}</title>
        {process.env.NEXT_PUBLIC_APP_ENV === 'prod' ? (<script>
            {`
              (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:2707955,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
              `}
          </script>) : null}
      </Head>
      <main>
        <MainSection width={1474} height={701} src={`/img/client-contact/${lang === 'pl' ? 'pl' : 'en'}/hero-img.png`} header={t('title' as const)} dsc={t('description' as const)} isCustom/>
        <EmailSection>
          <h2>{t('contactForm.findOut', 'common')}</h2>
          <span>
            <Trans i18nKey="common:contactForm.reviewPower" components={[<b key="b"/>]} fallback="commonEN:contactForm.reviewPower"/>
          </span>
        </EmailSection>
        <CommentReview />
        <Mediation />
        <FindOutMore />
        <Vip accounts={vipAccounts}>
          <HeaderSection header={t('vip.customerImplementations', 'common')} description={t('vip.customerInterviews', 'common')}/>
        </Vip>
      </main>
    </Page>);
}
const getStaticProps: GetStaticProps<ClientContactProps> = async (context: GetStaticPropsContext) => {
    const latestReviews = await getReviews({
        language: context.locale as string,
    });
    const vipAccounts = await getVipAccounts({
        allowedAccounts: getVipAccountIds(),
        sort: 'id',
        order: 'ASC',
    });
    return {
        props: { latestReviews, vipAccounts },
        revalidate: 60,
    };
};
export default ClientContact;

    async function __Next_Translate__getStaticProps__1972058d299__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/client-contact',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1972058d299__ as getStaticProps }
  